// @flow
/** @jsx jsx */

import { partial } from 'lodash';

import { createKeyHandler } from '@zapier/common-utils';
import { jsx } from '@emotion/core';
import { RadioButton, Text } from '@zapier/common-components';

const optionsContainerCss = {
  display: 'flex',
};

const radioCss = {
  display: 'flex',
  alignItems: 'center',
  '> *': {
    marginRight: 10,
  },
};

type RadioOption = {
  key: string,
  displayText: string,
};

type Props = {
  onSelectOption: (option: string) => void,
  options: RadioOption[],
  selectedOption: string,
};

const RadioButtonGroup = ({
  onSelectOption,
  options = [],
  selectedOption,
}: Props) => {
  const isSelected = option => selectedOption === option;

  return (
    <div css={optionsContainerCss}>
      {options.map(option => (
        <div
          aria-checked={isSelected(option.key)}
          css={radioCss}
          key={option.key}
          onClick={partial(onSelectOption, option.key)}
          onKeyDown={createKeyHandler(
            ['space'],
            partial(onSelectOption, option.key)
          )}
          role="radio"
          tabIndex={0}
        >
          <RadioButton checked={isSelected(option.key)} value={option.key} />
          <Text>{option.displayText}</Text>
        </div>
      ))}
    </div>
  );
};

export default RadioButtonGroup;
